<template>
<div
  :data-testid="`tab-${slugify(tab.name)}`"
  class="mlp-tab"
  :id="`tab-${slugify(tab.name)}-content`"
>
  <figure class="tab-image">
    <img
      :src="image"
      :alt="tab.name"
    >
  </figure>
  <div class="tab-content-holder">
    <div class="tab-header">
      <h2 class="tab-heading">{{tab.name}}</h2>
      <h3 class="tab-subheading">{{tab.subheading}}</h3>
    </div>
    <div class="tab-content">
      <p>{{tab.content}}</p>
    </div>
    <div class="tab-footer">
      <router-link :to="tab.target" class="elr-button elr-button-primary tab-link">{{tab.buttonText}}</router-link>
    </div>
  </div>
</div>
</template>

<script>
import { slugify } from '../../utils/helpers';

export default {
  name: 'PonyTab',
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  methods: {
    slugify
  },
  computed: {
    image() {
      return `${this.baseUrl ? this.baseUrl : ''}tab-images/${this.tab.image}`
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.mlp-tab {
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  width: 100%;
  position: absolute;

  @media (max-width: 1000px) {
    flex-direction: column;
    max-width: 461px;
    margin: auto;
  }

  > .elr-container {
    width: 100%;
  }
}

.tab-image {
  max-height: 375px;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-radius: 5px 0 0 5px;

  @media (max-width: 1000px) {
    width: 100%;
    height: auto;
  }

  img {
    border-radius: 5px 0 0 5px;
    width: auto;
    height: 100%;
    min-height: 100%;
    display: block;

    @media (max-width: 1000px) {
      width: 100%;
      height: auto;
    }
  }
}

.tab-header {
  padding-bottom: 20px;
}

.tab-heading {
  font-size: 24px;
  // text-transform: uppercase;
  font-weight: 900;
}

.tab-subheading {
  font-size: 18px;
  font-weight: 500;
}

.tab-heading,
.tab-subheading {
  margin: 0;
  padding: 0;
  line-height: 1.3;
}

.tab-content-holder {
  padding: 20px 40px;
  // font-weight: 500;
  width: 50%;

  @media (max-width: 1000px) {
    width: 100%;
  }
}

.tab-footer {
  padding-top: 20px;

  .tab-link {
    margin-bottom: 10px;
    margin-right: 10px;
  }
}
</style>
